export function generateQueryString(obj, prefix = '') {
  const pairs = [];

  for (const key in obj) {
    if (obj[key] === undefined || obj[key] === null) continue;

    const value = obj[key];
    const fullKey = prefix ? `${prefix}[${key}]` : key;

    if (typeof value === 'object' && !Array.isArray(value)) {
      pairs.push(generateQueryString(value, fullKey));
    } else if (Array.isArray(value)) {
      value.forEach((v, i) => {
        pairs.push(`${fullKey}[${i}]=${encodeURIComponent(v)}`);
      });
    } else {
      pairs.push(`${fullKey}=${encodeURIComponent(value)}`);
    }
  }

  return pairs.join('&');
}
